<template>
	<div>
		<q-select ref="speciesSelect"
				  :value="sword"
				  @input="selectSpecies"
				  use-input
				  fill-input
				  hide-selected
				  input-debounce="0"
				  :label="$t('species')"
				  :options="options"
				  @filter="filterSpecies"
				  :loading="speciesList.length === 0"
				  :error="error"
				  :error-message="errorMessage"
				  hide-bottom-space
		>
			<template v-slot:no-option="scope">
				<div class="q-pa-md" v-if="speciesList.length">{{ $t('noResults') }}</div>
				<div v-else class="q-pa-md text-center">
					<q-spinner-cube color="primary" size="3em"/>
				</div>
			</template>
			<template v-slot:option="scope">
				<q-item v-bind="scope.itemProps"
						v-on="scope.itemEvents"
						:key="scope.opt.uid"
						clickable
				>
					<template v-if="dense">
						{{ scope.opt.name }}
					</template>
					<template v-else>
						<q-img :src="scope.opt.teaser" :alt="scope.opt.name" class="species-selector-image" ratio="1" basic/>
						<p class="text-h6 q-px-lg">{{ scope.opt.name }}</p>
					</template>
				</q-item>
			</template>
		</q-select>
	</div>
</template>

<script>
	import {FETCH_ALL_SPECIES} from "@/store/actions.type";
	import {mapGetters} from "vuex";
	import LogSearchMixin from "@/mixins/LogSearchMixin";

	export default {
		name: "SpeciesSelector",
		mixins: [LogSearchMixin],
		props: {
			error: Boolean,
			errorMessage: {
				type: String,
				default: ''
			},
			preselectedSpecies: null,
			emit: {
				type: Boolean,
				default: false
			},
			dense: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				sword: '',
				options: [],
				selectedSpecies: null
			}
		},
		async mounted() {
			if (!this.speciesList.length) {
				await this.$store.dispatch(FETCH_ALL_SPECIES);
			}
			this.$refs.speciesSelect.filter(this.sword);
		},
		computed: {
			...mapGetters(['speciesList', 'watchlist', 'logSearchParams']),
		},
		watch: {
			selectedSpecies() {
				if (this.selectedSpecies) {
					this.sword = this.selectedSpecies.name;

					if (!this.emit) {
						this.newSpeciesLogSearch(this.selectedSpecies);
					}
				} else if (this.preselectedSpecies) {
					this.sword = this.preselectedSpecies.name;
				}
			},
			preselectedSpecies() {
        if(this.preselectedSpecies) {
          this.selectedSpecies = this.preselectedSpecies;
        }
			},
			/* updating selected species in multiple watchers to deal with race condition (not ideal, consider other solutions) */
			logSearchParams() {
				this.setPreselectedSpecies();
			},
			speciesList() {
				this.setPreselectedSpecies();
			},
			watchlist() {
				this.setPreselectedSpecies();
			}
		},
		methods: {
			filterSpecies(val, update, abort) {
				update(() => {
					const needle = val.toLowerCase().trim();
					this.options = this.speciesList.filter(species => species.name.toLowerCase().includes(needle));
				})
			},
			selectSpecies(species) {
				this.selectedSpecies = species;
				if (this.emit) {
					this.$emit('input', species);
				}
			},
			setPreselectedSpecies() {
				if (this.speciesList.length && !this.preselectedSpecies) {
					if (this.logSearchParams.species) {
						const currentSpecies = this.logSearchParams.species.uid || parseInt(this.logSearchParams.species);
						const preselectedSpecies = this.speciesList.filter(species => species.uid === currentSpecies);
						if (preselectedSpecies.length) {
							this.sword = preselectedSpecies[0].name;
						}
					} else {
						this.selectedSpecies = null;
						this.sword = '';
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.species-selector-image {
		max-width: 60px;

		@media(min-width: 600px) {
			max-width: 90px;
		}

		@media(min-width: 1024px) {
			max-width: 150px;
		}
	}
</style>